<template>
    <div :class="{ loading: loading, hide: hide }">
        <div class="wrapper-logo">
            <img alt="Logo" src="../assets/images/logo.svg" class="logo">
            <div class="circle-container">
                <div class="loading">
                    <div class="trace"></div>
                    <div class="mask"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref } from 'vue';

    const loading = ref('loading');
    const hide = ref('hide');

    defineExpose({ loading, hide });
</script>

<style lang="scss" scoped>
    @keyframes logo-animation {
        0% {
            transform: rotate(360deg);
        }

        100% {
            transform: rotate(0deg);
        }
    }

    .wrapper-logo-container {
        width: 100%;
        height: 100%;
        position: fixed;
        background-color: rgba(255, 255, 255, 0.6);
        z-index: 999999;
        opacity: 0;
        transition: linear 0.25s opacity;

        &.deep {
            background-color: rgba(255, 255, 255, 1);
        }

        &.hide {
            display: none;
        }

        &.loading {
            opacity: 1;
        }

        &.excel {
            background-color: rgba(255, 255, 255, 0.9);

            .logo {
                height: 125px !important;
                left: 35px !important;
                top: 33px !important;
            }

            .wrapper-logo {
                width: 200px;
                height: 200px;
            }
        }

        .wrapper-logo {
            color: #0f4470;
            text-align: center;
            width: 150px;
            display: block;
            overflow: hidden;
            margin: auto;
            position: relative;
            height: 150px;
            margin-top: 50vh;
            transform: translateY(-50%);

            .logo {
                display: table;
                z-index: 9999;
                margin: 10px auto;
                left: 3px;
                top: -7px;
                position: absolute;
                height: 145px;
                transition-timing-function: cubic-bezier(.4,0,1,1);
                transition-property: opacity;
            }

            .circle-container {
                animation: logo-animation 1s infinite;
                animation-timing-function: linear;
                animation-direction: reverse;
                width: 150px;
                height: 150px;
                background: linear-gradient(0deg, rgba(14,79,128,1) 0%, rgba(21,39,64,1) 50%, rgba(19,35,53,1) 100%);
                border-radius: 50%;
                margin: 0 auto;

                .loading {
                    display: block;
                    width: 160px;
                    height: 160px;
                }

                .trace {
                    position: relative;
                    left: -5px;
                    width: 145px;
                    height: 145px;
                    background: rgba(217, 217, 217, 0.95);
                    border-radius: 50%;
                    margin: 0 auto;
                }

                .mask {
                    position: relative;
                    left: -65px;
                    top: -75px;
                    width: 150px;
                    height: 185px;
                    //background: rgba(255, 255, 255, 0.60);
                    transform: rotate(45deg);
                }

                .dot {
                    position: relative;
                    left: 109px;
                    top: -198px;
                    width: 7px;
                    height: 7px;
                    background: #0f4f82;
                    border-radius: 50%;
                }
            }
        }
    }
</style>